export default {
  data() {
    return {
      roles: [
        {
          label: "总管理员",
          value: 1
        },
        {
          label: "基地管理员",
          value: 2
        },
        {
          label: "授课导师",
          value: 3
        },
        {
          label: "辅导员",
          value: 4
        },
        {
          label: "学员",
          value: 5
        }
      ],
      adminRoles: [
        {
          label: "管理员",
          value: 2
        },
        {
          label: "授课导师",
          value: 3
        },
        {
          label: "辅导员",
          value: 4
        }
      ]
    };
  }
};
